import { CommonService } from 'src/app/services/common/common.service';
import { Component, Inject } from '@angular/core';
import { AppService } from 'src/app/services/app/app.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddDocumentComponent } from '../add-document/add-document.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from 'src/app/services/document/document.service';
import { DocPack, DocumentCollection } from 'src/app/model/doc_pack';
import { PopoverService } from '../../custom-delete-popover/popover.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-document-pack',
  templateUrl: './add-document-pack.component.html',
  styleUrls: ['./add-document-pack.component.scss']
})
export class AddDocumentPackComponent {

  public documentPackArr:DocPack[]=[
    {
      name:"",
      doc_arr:[],
      isErr:false,
    }
  ]
  public userInfo:any
  public imageURL:string=GlobalService.imageURL;
  public packId!:number;
  public isSpinnerLoading:boolean=false;
 
  constructor(private commonService :CommonService,private appService:AppService,private dialog:MatDialog,private dialogRef :MatDialogRef<AddDocumentPackComponent>,
    private docService:DocumentService,@Inject(MAT_DIALOG_DATA) public dialogData:any,public popoverService: PopoverService,private spinner:NgxSpinnerService){}
  ngOnInit(): void {
    this.userInfo= this.appService.getData('training-portal.userInfo')
    if (this.dialogData && (this.dialogData.pack_id)){
      this.packId=this.dialogData.pack_id;
      this.getPackDetails()
    }
  }
  deleteItem(id,sub_id,doc_id):any {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "document", id: id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        if(this.documentPackArr[id].doc_arr[sub_id].hasOwnProperty('id')){
          this.deleteDoc(doc_id,id,sub_id)
        }
        else{
          this.documentPackArr[id].doc_arr.splice(sub_id,1)
        }
      }
    });
  }
  deleteDoc(doc_id,id,sub_id){
    let data={
      "pack_id":this.packId,
      "doc_id":doc_id
  }
    this.isSpinnerLoading=true;
    this.docService.deleteDocument(data).subscribe({
      next: (result: any) => {
        if (result.status == 200) {
          this.documentPackArr[id].doc_arr.splice(sub_id, 1);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  togglePopover(i: number): void {
    if (this.popoverService.isPopoverVisible(i)) {
      this.popoverService.hidePopover(i);
    } else {
      // Close the currently open popover (if any)
      const currentlyOpenPopover = this.popoverService.getCurrentPopoverIndex();
      if (currentlyOpenPopover !== null) {
        this.popoverService.hidePopover(currentlyOpenPopover);
      }
      // Show the clicked popover
      this.popoverService.showPopover(i);
    }
  }
  getPackDetails(){
    this.isSpinnerLoading=true
    this.docService.getPackDetail(this.packId).subscribe((result:any)=>{
      this.isSpinnerLoading=false;
      let newObject={
        name:result.p_n,
        doc_arr:result.msg,
        id:this.packId,
      }
      this.documentPackArr=[]
      this.documentPackArr.push(newObject)
    })
  }
  onDeleteItem(id:number){
    this.documentPackArr.splice(id,1)
  }
  onDeleteDoc(i:number,j:number){
    this.documentPackArr[i].doc_arr.splice(j,1)
  }
  onAddDocumentPack(){
    let obj:DocPack= {
      name:"",
      doc_arr:[],
      isErr:false
    }
    this.documentPackArr.push(obj)
  }
  onAddEditDocument(id:any,sub_id:any,value:any){
    let data={
      width: '60%', minWidth: '280px', height: '90%', maxHeight: '700px',maxWidth:'800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
    }
    if(value!=''){
      data["data"]=value
    }
    const dialogRef = this.dialog.open(AddDocumentComponent,data);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if(this.documentPackArr[id]['isErr']==true){
          this.documentPackArr[id]['isErr']=false;
        }
        if(sub_id===''){
          if(this.packId){result["id"]=''}
          this.documentPackArr[id].doc_arr.push(result)
        }
        else{
          this.documentPackArr[id].doc_arr[sub_id]=result
        }


        // if(id!=''{})
        // this.getList()
      }

    });
  }
  onCancel(){
    this.dialogRef.close()
  }
  onSaveDocumentPack(){
    this.checkError()
    if(!this.checkError()){
      this.documentPackArr.map(item=>{
        delete item["isErr"]
      })
      let dataObj:DocumentCollection={
        doc_data:this.documentPackArr
      }
      if(this.documentPackArr.length >0){
        if(this.packId){
          this.spinner.show()
          this.docService.editDocPack(dataObj).subscribe((result:any)=>{
            if(result.status==200){
              this.spinner.hide()
              this.appService.showToastMessage('success',result.msg)
               this.dialogRef.close({data_added:true})
            }
           })
        }
        else{
          this.spinner.show()
          this.docService.addDocPack(dataObj).subscribe((result:any)=>{
            if(result.status==200){
              this.spinner.hide()
             this.appService.showToastMessage('success',result.msg)
             this.dialogRef.close({data_added:true})
            }
         })
       
        }
      }
    }
  
  }

  checkError(){
    let isErrorPresent:boolean=false
    for(let i=0;i<this.documentPackArr.length;i++){
      
       if(this.documentPackArr[i].doc_arr.length==0 || (this.documentPackArr[i]['name']=='')){
        isErrorPresent=true;
        this.documentPackArr[i]['isErr']=true;
        // return
       }
    }
    return isErrorPresent
    if(isErrorPresent){return}
  }
}
